import * as routes from "../../constants/routes";
import React from "react";
import {Link} from "react-router-dom";

export default function NavigationDemo() {
    return (
        <ul>
            <li>Organic / Direct Applications</li>
            <ul>
                <li>
                    <Link to={routes.ORGANIC_LANDING}>Landing Page</Link>
                </li>
                <li>
                    <Link to={routes.ORGANIC_APP}>Application Page</Link>
                </li>
            </ul>

            <li>Invite / PAL Applications</li>
            <ul>
                <li>
                    <Link to={routes.INVITE_LANDING}>Landing Page</Link>
                </li>
                <li>
                    <Link to={routes.INVITE_APP}>Application Page</Link>
                </li>
                <li>
                    <Link to={routes.FORGOT_INVITE}>Forgot Invite</Link>
                </li>
            </ul>
            <li>
                <Link to={routes.CONGRATULATIONS}>Approved Extra Info</Link>
            </li>

            <li>Decision Pages</li>
            <ul>
                <li>
                    <Link to={routes.APPROVED_DEFAULT}>Approved</Link>
                </li>
                <li>
                    <Link to={routes.THANK_YOU}>Declined</Link>
                </li>
                <li>
                    <Link to={routes.DUPLICATE}>Duplicate</Link>
                </li>
                <li>
                    <Link to={routes.PROCESSING}>Processing</Link>
                </li>
            </ul>

            <li>
                <Link to={routes.REVIEW_COMPLETE}>Review Completed</Link>
            </li>

            <li>Refer A Friend</li>
            <ul>
                <li>
                    <Link to={routes.REFERRAL_PAGE}>Approved Applicant Referral Page</Link>
                </li>
                <li>
                    <Link to={routes.REFERRAL_SHARE}>Personal Link Page</Link>
                </li>
                <li>
                    <Link to={routes.REFERRAL_CLAIM}>Referred Friend Landing Page</Link>
                </li>
            </ul>
        </ul>
    );
}
